import { Fact, FactToCheck, ProductConfig } from '../types';

export function determineIsProductConfigIncludeAllFields(factsToCheck: FactToCheck[], config: ProductConfig) {
  return factsToCheck.reduce<{
    isConfigComplete: boolean;
    requiresForSet: Fact[];
  }>(
    (acc, fact) => {
      if (!config?.[fact?.factKey]) {
        acc.requiresForSet.push(
          fact.factKey
            .replace(/_/g, ' ')
            .toLowerCase()
            .replace(/\b(\w)/g, char => char.toUpperCase())
        );
      }

      acc.isConfigComplete = factsToCheck.every(fact => config?.[fact?.factKey] != null);

      return acc;
    },
    { isConfigComplete: !factsToCheck.length, requiresForSet: [] }
  );
}
